import React, { useState } from 'react';
import { HeroProductCardProps } from '../types';
import { ButtonWithAnchor } from '../../income-tax/page-sections/hero-section/sticky-button';
import { ButtonVariants } from '../../Atoms/Button';

const HeroProductCard: React.FC<HeroProductCardProps> = ({ card }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className={`px-6 mx-2 py-6 relative sm:w-full flex flex-col justify-between w-1/3 rounded-3xl sm:pb-8 md:w-2/5 transition-all duration-500 border-2 border-transparent
        ${card.hoverBgColor}
      `}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <img
        src={card.icon}
        alt=""
        width="60"
        className="ml-auto mr-auto absolute left-0 right-0 -top-8"
      />

      <div className="h-full">
        <h3
          className={`
            text-3xl sm:text-2xl font-bold pt-6 transition-opacity duration-1000 text-center
            ${isHovered ? 'opacity-0' : 'opacity-100'}
          `}
        >
          {card.heading}
        </h3>
      </div>

      <p
        className={`text-base mt-auto absolute w-full px-6 md:px-0 md:pt-0 md:top-8 sm:pt-0 lg:top-6 lg:pt-0 sm:top-8 text-font-500 text-center transition-opacity duration-1000 left-0 top-12
          ${isHovered ? 'opacity-100' : 'opacity-0'}
        `}
      >
        {card.content}
      </p>

      <div className="pt-6 w-11/12 mx-auto">
        <ButtonWithAnchor
          buttonText={card.buttonText}
          buttonLink={card.CTAButtonLink}
          trackLabel={`hero_cta_${card.heading
            .toLowerCase()
            .replace(/\s+/g, '_')}`}
          buttonVariant={ButtonVariants.bluefilled}
          target="_blank"
          className="h-14"
        />
      </div>
    </div>
  );
};

export default HeroProductCard;
